import { defineNuxtPlugin } from '#app'

// Propaga la invalidacion de catalogos entre pestañas del mismo navegador.
// Cuando invalidateCatalog() corre en una pestaña, escribe la clave
// CATALOG_INVALIDATE_PING_KEY en localStorage; las demas pestañas reciben el
// evento 'storage' y refrescan su contador reactivo local (las claves de
// localStorage ya fueron borradas por la pestaña que origino la invalidacion).

export default defineNuxtPlugin(() => {
  window.addEventListener('storage', (e) => {
    if (e.key !== CATALOG_INVALIDATE_PING_KEY || !e.newValue) return

    try {
      const payload = JSON.parse(e.newValue)
      if (Array.isArray(payload?.slugs)) {
        applyRemoteCatalogInvalidation(payload.slugs)
      }
    } catch { /* payload corrupto: ignorar */ }
  })
})
